import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { DashboardProvider } from './context/DashboardContext';
import { ProfileProvider } from './context/ProfileContext';

// Set favicon dynamically
const setFavicon = (url) => {
  const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.type = 'image/jpeg';
  link.rel = 'shortcut icon';
  link.href = url;
  document.getElementsByTagName('head')[0].appendChild(link);
};

// Set favicon on load
setFavicon('/favicon.ico.jpg');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DashboardProvider>
      <ProfileProvider>
        <App />
      </ProfileProvider>
    </DashboardProvider>
  </React.StrictMode>
);